import { Typography, Box, Paper } from "@mui/material";
import { BarChart } from "@mui/x-charts";
import Grid from "@mui/material/Grid2";
import { EntityDataModel } from "./types";
import { chartPalette, formatFieldName, valueFormatter } from "../helpers";

const CleaningBarChart = ({
  entityData,
}: {
  entityData: EntityDataModel[];
}) => {
  return (
    <Box sx={{ marginTop: 3 }}>
      <Grid container spacing={2}>
        {entityData?.map((entity) => (
          <Grid size={{ xs: 12, sm: 6, lg: 6 }} key={entity.entityName}>
            <Paper
              sx={{
                padding: 2,
                textAlign: "center",
              }}
            >
              <Typography
                variant="h6"
                color="primary"
                gutterBottom
                key={entity.entityName}
              >
                {entity.entityName}
              </Typography>
              {entity.fieldData.length < 7 ? (
                <BarChart
                  dataset={entity.fieldData?.map((item) => ({
                    ...item,
                  }))}
                  series={[
                    {
                      dataKey: "count",
                      valueFormatter,
                    },
                  ]}
                  yAxis={[
                    {
                      dataKey: "name",
                      tickLabelInterval: (value) => Number.isInteger(value),
                    },
                  ]}
                  xAxis={[
                    {
                      scaleType: "band",
                      dataKey: "name",
                      colorMap: {
                        type: "ordinal",
                        colors: chartPalette,
                      },
                      valueFormatter: formatFieldName,
                    },
                  ]}
                  height={400}
                />
              ) : (
                <BarChart
                  dataset={entity.fieldData?.map((item) => ({
                    ...item,
                  }))}
                  yAxis={[
                    {
                      scaleType: "band",
                      dataKey: "name",
                      colorMap: {
                        type: "ordinal",
                        colors: chartPalette,
                      },
                      valueFormatter: formatFieldName,
                    },
                  ]}
                  xAxis={[
                    { tickLabelInterval: (value) => Number.isInteger(value) },
                  ]}
                  series={[{ dataKey: "count", valueFormatter }]}
                  layout="horizontal"
                  grid={{ vertical: true }}
                  margin={{
                    left: 120,
                  }}
                  height={400}
                />
              )}
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CleaningBarChart;
